import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  MyEdiaryActionTypes,
  MyEdiaryActions
} from './my-ediary-store.actions';

interface MyEdiaryState {
  eDiary: any;
  selectedEdiary: any;
  pending: boolean;
}

export const myEdiaryInitialState: MyEdiaryState = {
  eDiary: undefined,
  selectedEdiary: undefined,
  pending: undefined
};

export function myEdiaryReducer(
  state = myEdiaryInitialState,
  action: MyEdiaryActions
): MyEdiaryState {
  switch (action.type) {
    case MyEdiaryActionTypes.LOAD_EDIARY:
      return { ...state, eDiary: { activity: [], unformattedActivity: [] } };

    case MyEdiaryActionTypes.LOAD_EDIARY_SUCCESS:
      return { ...state, eDiary: action.payload };

    case MyEdiaryActionTypes.LOAD_EDIARY_PENDING:
      return { ...state, pending: action.payload };

    case MyEdiaryActionTypes.LOAD_EDIARY_DETAIL:
      return { ...state, selectedEdiary: action.payload };

    default:
      return state;
  }
}

const ediaryState = createFeatureSelector<MyEdiaryState>('myEdiary');

export const selectorMyEdiary = createSelector(
  ediaryState,
  state => state.eDiary
);

export const selectorMySelectedEdiary = createSelector(
  ediaryState,
  state => state.selectedEdiary
);

export const selectorMyEdiaryPending = createSelector(
  ediaryState,
  state => state.pending
);
